import { ITaxServiceMock } from './tax.mock.types';

export const mockTaxService = (): ITaxServiceMock => ({
  fetchTaxes: jest.fn(),
  fetchTax: jest.fn(),
  createTax: jest.fn(),
  updateTax: jest.fn(),
  deleteTax: jest.fn()
});
